<script setup lang="ts">

import Skeleton from 'primevue/skeleton'
</script>

<template>
<div class="mansory-wall__skeleton__wrapper">
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
  <Skeleton width="316px" height="690px" borderRadius="40px"></Skeleton>
</div>
</template>

<style scoped>
.mansory-wall__skeleton__wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap:20px;
}
</style>